import { gql } from '@apollo/client';

const GET_TRACKINGS = gql`
  query getTrackings(
    $projectId: String!
    $userFlowUrl: String!
    $userFlowStepUrls: [String]
  ) {
    userFlowStepTrack {
      getTrackings(projectId: $projectId, userFlowUrl: $userFlowUrl, userFlowStepUrls: $userFlowStepUrls) {
        id
        userFlowStep {
          url
          stepName
          id
          isComplete
          lastViewedContentPageCompletion {
            contentPage {
              url
            }
          }
          sort
        }
    
        answers {
          id
          ... on QuestionAnswerCheckboxType {
            contentSnippetQuestion {
              id
              questionText: question
            }
            selectedAnswers {
              questionAnswerCheckboxId
              questionResponseCheckboxId
            }
          }

          ... on QuestionAnswerMultilineTextType {
            text
          }

          ... on QuestionAnswerRadioType {
            questionResponseRadioId
            contentSnippetQuestionId
          }
        }
        
      }
    }
  }
`;

export { GET_TRACKINGS };
